import { Injectable, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import type { SeoDto } from '../models/site-api.model';

@Injectable({ providedIn: 'root' })
export class SeoService {
  private readonly title = inject(Title);
  private readonly meta = inject(Meta);

  apply(seo: SeoDto): void {
    this.title.setTitle(seo.title);
    this.meta.updateTag({ name: 'description', content: seo.description });
    this.meta.updateTag({ property: 'og:title', content: seo.ogTitle });
    this.meta.updateTag({ property: 'og:description', content: seo.ogDescription });
  }
}
